// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question-share__content[data-v-497a9c24]{border-radius:.32rem .32rem 0 0;background:#fff}", ""]);
// Exports
module.exports = exports;
